import type { CoachSessionPrepData } from "@/hooks/useCoachSessionPrepData";
import type { CoachLensSource, CoachMemorySource, CoachTwinSource } from "@/lib/coachSessionReviewContract";
import { buildCoachDigitalTwinRuntimeFromSources } from "@/lib/behavior/coachRuntime";

export function resolveCoachSessionPrepRuntimeSources(params: {
  prepCoachLens: CoachSessionPrepData["coachLens"] | null;
  activeCoachLens: CoachLensSource | null;
  activeCoachTwin: CoachTwinSource | null;
}) {
  const coachLensSource = params.activeCoachLens || (
    params.prepCoachLens
      ? {
          lens_name: "Custom coach identity",
          preferred_language: [],
          avoid_language: [],
          frameworks: [],
          coach_lens_json: {
            philosophy: params.prepCoachLens.coaching_philosophy,
            frameworks_raw: params.prepCoachLens.frameworks,
          },
        }
      : null
  );

  const coachTwinSource = params.activeCoachTwin || (
    params.prepCoachLens?.voice_summary
      ? {
          voice_summary: params.prepCoachLens.voice_summary,
          question_stems: [],
          phrase_bank: [],
          avoid_list: [],
          guardrails: [],
        }
      : null
  );

  return {
    coachLensSource,
    coachTwinSource,
  };
}

export function buildCoachSessionPrepIdentityRuntime(params: {
  prepCoachLens: CoachSessionPrepData["coachLens"] | null;
  activeCoachLens: CoachLensSource | null;
  activeCoachTwin: CoachTwinSource | null;
  activeCoachMemory: CoachMemorySource | null;
}) {
  const { coachLensSource, coachTwinSource } = resolveCoachSessionPrepRuntimeSources({
    prepCoachLens: params.prepCoachLens,
    activeCoachLens: params.activeCoachLens,
    activeCoachTwin: params.activeCoachTwin,
  });

  return {
    coachLensSource,
    coachTwinSource,
    coachMemorySource: params.activeCoachMemory,
    runtime: buildCoachDigitalTwinRuntimeFromSources({
      coachLens: coachLensSource,
      coachTwin: coachTwinSource,
      contextType: "session",
    }),
  };
}
